const defaultWidth = 5;

export const admissionDatabaseAllFieldsList = [
  { title: "Date", id: "data_added", width: defaultWidth },
  { title: "Full Name", id: "full_name", width: defaultWidth },
  { title: "Title", id: "title", width: defaultWidth },
  { title: "Type", id: "document_type", width: defaultWidth },
  { title: "Seria", id: "document_seria", width: defaultWidth },
  { title: "Data of Birth", id: "date_of_birth", width: defaultWidth },
  { title: "Nationality", id: "nationality", width: defaultWidth },
  { title: "Course", id: "course", width: defaultWidth },
  { title: "Whose", id: "whose_doc", width: defaultWidth },
];

export const admissionDatabaseDefaultConfiguration = [
  { title: "Date", id: "data_added", width: 5.5 },
  { title: "Full Name", id: "full_name", width: 14 },
  { title: "Title", id: "title", width: 6.875 },
  { title: "Type", id: "document_type", width: 6 },
  { title: "Seria", id: "document_seria", width: 6.313 },
  { title: "Data of Birth", id: "date_of_birth", width: 5.5 },
  { title: "Nationality", id: "nationality", width: 6.5 },
  { title: "Course", id: "course", width: 11.625 },
  { title: "Whose", id: "whose_doc", width: 5.875 },
  // { title: "Actions", id: "document_actions", width: 9 },
];

export const admissionDatabaseDefaultBodyFilters = {
  page: 1,
  query: "",
  start: "",
  end: "",
  types: [],
  nationalities: [],
  courses: [],
  whose_docs: [],
  titles: [],
};
